"use client"

import Script from "next/script"

// This will be read from environment variables
const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID

/**
 * Renders the Google Tag Manager container script.
 * It ensures GTM is loaded only on the client-side after the page is interactive.
 * A placeholder ID is used if the environment variable is not set, but GTM will not function correctly.
 */
export function GoogleTagManager() {
  if (!GTM_ID) {
    console.warn(
      "Google Tag Manager ID (NEXT_PUBLIC_GTM_ID) is not set. GTM will not be initialized."
    )
    return null
  }

  return (
    <Script
      id="google-tag-manager"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
        `,
      }}
    />
  )
}
